const form = {
  formId: "tax-personal-05",
  formField: {
    organizeName: {
      name: "organ1",
      label: "1. Tên tổ chức, cơ quan chi trả thu nhập",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập cơ quan thuế cấp cục",
    },
    taxId: {
      name: "taxId",
      label: "2. Mã số thuế",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập cơ quan thuế quản lý",
    },
  },
};

export default form;
